<template>
    <div class="product-param mb-4 px-3">
        <div class="row">
            <div class="col-md-12 mb-2">{{ label }}:</div>

            <div class="col-md-12 mb-2">
                <div class="product-param-container" :class="{ numerical: type != 'color' }">
                    <div
                        v-for="item in list"
                        :key="item.id"
                        :class="{ active: selection.value && item.id == selection.value.replace('color_', ''), available: isAvailable(item.id) }"
                        @click="onClick(item.id)"
                    >{{ item.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductColor',
    props: ['list', 'type', 'label', 'selection', 'available'],
    methods: {
        isAvailable(item){
            if(Array.isArray(this.available)){
                let available = this.available.map(value => value.value.replace('color_', ''));
                return available.includes(item.toString());
            }

            return false;
        },
        onClick(item){
            if(this.isAvailable(item))
                this.$emit('selected', { value: 'color_' + item, type: this.type });
        }
    }
}
</script>